
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const ShopHero = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-violet-50 to-purple-100">
      <div className="container-custom mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-10">
        <div className="order-2 md:order-1">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            The Best Products for Your Underarm Health
          </h1>
          <p className="text-lg mb-6">
            Find high-quality, effective deodorants and underarm care products 
            that we've personally tested and recommend.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="shadow-md bg-primary text-primary-foreground">
              <Link to="/deodorant-quiz">Find Your Perfect Match</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="shadow-sm bg-white text-foreground border-border">
              <Link to="/shop">Shop Products</Link>
            </Button>
          </div>
        </div>
        <div className="order-1 md:order-2 flex justify-center">
          <img
            src="/lovable-uploads/dfd030d9-652d-4a06-95f1-a4eb346dddfc.png"
            alt="Featured deodorant products"
            className="rounded-xl shadow-lg max-h-80 object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default ShopHero;
